import { useEffect } from 'react';
import { useBlog } from '../contexts/BlogContext';

/**
 * Hook to update the sitemap when blog posts change
 * This is a client-side hook that will trigger sitemap regeneration
 * when the blog posts change in localStorage
 */
const useSitemapUpdater = () => {
  const { posts } = useBlog();
  
  useEffect(() => {
    // This effect runs when posts change
    const updateSitemap = async () => {
      try {
        // In a real production environment, this would call a serverless function
        // or API endpoint to regenerate the sitemap on the server
        console.log('Blog posts changed, sitemap should be updated');
        
        // For now, we'll just log the posts that would be included in the sitemap
        const publishedPosts = posts.filter(post => post.published);
        console.log(`Sitemap would include ${publishedPosts.length} published blog posts`);
        
        // In a real implementation, we would call an API endpoint here
        // Example: await fetch('/api/regenerate-sitemap', { method: 'POST' });
      } catch (error) {
        console.error('Error updating sitemap:', error);
      }
    };
    
    // Only run if we have posts
    if (posts.length > 0) {
      updateSitemap();
    }
  }, [posts]);
  
  return null; // This hook doesn't render anything
};

export default useSitemapUpdater;